/***
 *
 *   ACCOUNT
 *   Index page for account functions
 *
 **********/

import { useContext } from 'react';
import { AuthContext, Animate, Grid, Card, Icon, Link } from 'components/lib';

export function Account() {
  const authContext = useContext(AuthContext);
  const iconSize = 20;
  const isOwner = authContext.permission?.owner;
  const hasRestrictedAccountAccess =
    authContext.user?.plan === false ||
    (!!authContext.user?.subscription &&
      authContext.user.subscription !== 'active' &&
      authContext.user.permission !== 'master');

  return (
    <Animate>
      {/* User Settings Section */}
      <section className="mb-4">
        <h2 className={Style.sectionHeader}>User Settings</h2>
        <Grid cols="3" gap="4">
          <Card isStat={true}>
            <Icon image="user" size={iconSize} />
            <h3 className={Style.subtitle}>Profile</h3>
            <div>Update your profile information</div>
            <Link url="/account/profile" className={Style.link}>
              Update
            </Link>
          </Card>
          <Card isStat={true}>
            <Icon image="lock" size={iconSize} />
            <h3 className={Style.subtitle}>Password</h3>
            <div>Change your password</div>
            <Link url="/account/password" className={Style.link}>
              Change
            </Link>
          </Card>
        </Grid>
      </section>
      {/* Organization Settings Section */}

      {authContext.permission?.admin && (
        <section className="mt-4">
          <h2 className={Style.sectionHeader}>Organization Settings</h2>
          <Grid cols="3" gap="4">
            {/* {context.permission?.developer && (
          <Card isStat={true}>
            <Icon
              image='settings'
              size={iconSize}
            />
            <h2 className={Style.subtitle}>API Keys</h2>
            <div>Manage your API keys</div>
            <Link
              url='/account/apikeys'
              className={Style.link}
            >
              Manage
            </Link>
          </Card>
        )} */}

            {isOwner && (
              <Card isStat={true}>
                <Icon image="briefcase" size={iconSize} />
                <h3 className={Style.subtitle}>Organization</h3>
                <div>Manage your organization</div>
                <Link url="/account/organization" className={Style.link}>
                  Manage
                </Link>
              </Card>
            )}

            {authContext.user?.plan !== false && authContext.permission?.admin && (
              <Card isStat={true}>
                <Icon image="users" size={iconSize} />
                <h3 className={Style.subtitle}>Users</h3>
                <div>Invite users to your account</div>
                <Link url="/account/users" className={Style.link}>
                  Add users
                </Link>
              </Card>
            )}

            {authContext.user?.plan !== false && authContext.permission?.admin && (
              <Card isStat={true}>
                <Icon image="settings" size={iconSize} />
                <h3 className={Style.subtitle}>Projects Access</h3>
                <div>Manager user project access</div>
                <Link url="/account/project-access" className={Style.link}>
                  Manage
                </Link>
              </Card>
            )}

            {(!hasRestrictedAccountAccess || authContext.permission?.owner) && authContext.permission?.admin && (
              <Card isStat={true}>
                <Icon image="credit-card" size={iconSize} />
                <h3 className={Style.subtitle}>Subscription</h3>
                <div>See subscription and payment details</div>
                <Link url="/account/subscription" className={Style.link}>
                  View
                </Link>
              </Card>
            )}
          </Grid>
        </section>
      )}
    </Animate>
  );
}

const Style = {
  sectionHeader: 'text-xl font-semibold mb-4',
  subtitle: 'font-bold mt-4 text-lg',
  link: 'text-blue-500 font-semibold mt-3 inline-block',
};
